/**
 * juliette-voice-filters — filtres de transcription vocale Juliette (logique pure).
 *
 * Contexte : le STT (gpt-4o-transcribe) HALLUCINE sur du silence/bruit et renvoie
 * parfois de la camelote NON vide ("###", '""', "...") ou une phrase inventee. Le
 * seul garde-fou historique cote hook (transcript vide) laissait passer cette
 * camelote comme un vrai tour utilisateur -> Juliette "s'emballait toute seule".
 *
 * `hasRealWord` rejette les transcriptions sans aucun vrai mot, SANS casser les
 * vraies reponses courtes ("oui", "non"). Pur et sans I/O : testable en isolation.
 */

/**
 * Vrai mot = au moins un groupe d'au moins 2 lettres (accents/unicode inclus).
 *
 * Exemples :
 *  - "###" / '""' / "..." / "" / "42" -> false (aucun vrai mot)
 *  - "oui" / "Oui." / "Bonjour Madame" -> true
 */
export function hasRealWord(text: string): boolean {
  return /\p{L}{2,}/u.test(text);
}
